import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/purchase-budget", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/purchase-budget/csv", params);
};

const get = id => {
  return restApi.get(`/api/purchase-budget/${id}`);
};

const upsert = data => {
  return restApi.post("/api/purchase-budget/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/purchase-budget/${ids}`);
};

const purchaseBudgetService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove
};

export default purchaseBudgetService;